module.exports = __webpack_public_path__ + "static/presidents-message-f7c5407379222cefa32a31a5a40533c8.jpg";